module.exports = __webpack_public_path__ + "static/media/Insta1.a84b0181.png";